module.exports = __webpack_public_path__ + "static/img/outwork-green.33d396a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outwork-green.png
// module id = ZioR
// module chunks = 62